import Image from 'next/image';
import capture from '../assets/faq/capture.png';
import analyze from '../assets/faq/analyse.png';
import alert from '../assets/faq/alert.png';
import circularMap from '../assets/faq/circularMap.png';
import eto from '../assets/faq/eto.png';
import rectangularMap from '../assets/faq/rectangularMap.png';

export const FaqContent = [
  {
    title: 'How does Fyllo device works?',
    content: () => {
      return (
        <div className="grid md:grid-cols-3 gap-4 h-full">
          <div className="grid place-items-center">
            <Image
              src={capture}
              alt="how fyllo work - capture images"
              sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"
            />
            <p className="px-6">
              Fyllo device capture data of different parameters with the help of its 11 sensors at a regular time
              interval.{' '}
            </p>
          </div>
          <div className="grid place-items-center">
            <Image
              src={analyze}
              alt="how fyllo work - Analysis images"
              sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"
            />
            <p className="px-8">
              Further the received data is analyzed with the help of Fyllo&apos;s Weather & Agronomical Algorithms{' '}
            </p>
          </div>
          <div className="grid place-items-center">
            <Image
              src={alert}
              alt="how fyllo work - Alert images"
              sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"
            />
            <p className="px-6">
              Instant alerts for disease and pest, irrigation and fertigation management, and weather prediction are
              delivered through our user-friendly dashboard and mobile app for proactive farm management.
            </p>
          </div>
        </div>
      );
    },
  },
  {
    title: 'How much area does one Fyllo device cover',
    content: () => {
      return (
        <div className="py-10 ">
          <div className="flex md:gap-10">
            <div className="w-1/2 text-left md:text-xl md:flex md:justify-end md:items-center">
              <p className="md:w-1/2">
                Our Main unit has a 1km radius coverage for weather parameters. For irrigation management, our Main unit
                is installed on the farm plot and covers that specific area, allowing farmers to closely monitor soil
                moisture levels and optimize irrigation practices for maximum crop yield.
              </p>
            </div>
            <div className="w-1/2">
              <Image
                className="w-auto md:h-80"
                src={circularMap}
                alt="How much area does one Fyllo device cover"
                sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"
              />
            </div>
          </div>

          <div className="flex md:gap-10">
            <div className="w-1/2 p-2 md:flex md:justify-end">
              <Image
                className="w-auto md:h-80"
                src={rectangularMap}
                alt="how fyllo work - capture images"
                sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"
              />
            </div>
            <div className="w-1/2 text-left md:text-xl md:flex md:justify-start md:items-center">
              <p className="md:w-1/2">
                For rest of the plots separate Nero devices has to be installed for Irrigation Management.{' '}
              </p>
            </div>
          </div>
        </div>
      );
    },
  },
  {
    title: 'What is soil water storage (commonly called water tank of crop) ?',
    content: () => {
      return (
        <div className="p-2">
          Soil water storage refers to the total amount of water stored in the soil within the plant&apos;s root zone,
          which is determined by the soil texture and crop rooting depth. Deeper roots mean a larger volume of water can
          be stored, providing a larger reservoir for the crop to draw upon between irrigations. Understanding the soil
          water storage capacity enables irrigators to determine the optimal amount of water to apply and how long to
          wait between each irrigation. For instance, on sandy soils with a low water storage capacity, less water would
          be applied at one time compared to loam soils with a higher water storage capacity.
        </div>
      );
    },
  },
  {
    title: 'What is ETO? ',
    content: () => {
      return (
        <div className="p-2 grid grid-cols-2 place-items-center">
          <div>
            Evapotranspiration is the combination of evaporation and transpiration, representing the movement of water
            from both the leaf and land surfaces to the atmosphere. ETO, or reference evapotranspiration, is a crucial
            factor in determining irrigation requirements and frequency. As ETO increases, so does the amount of water
            that needs to be applied to maintain optimal soil moisture levels for plant growth.
          </div>
          <Image
            src={eto}
            alt="What is ETO?"
            sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"
          />
        </div>
      );
    },
  },
  {
    title: 'How can our device predict diseases and pests?',
    content: () => {
      return (
        <div className="p-2 grid grid-cols-1">
          <p>
            Our device captures data on various parameters through sensors, then analyzes it using different agronomic
            algorithms, including models for detecting diseases and pests.
          </p>
          <p>
            Each disease and pest has a specific etiology, which refers to the environmental conditions that are most
            suitable for its incidence.
          </p>
        </div>
      );
    },
  },
  {
    title:
      'How can the soil moisture sensor monitor the irrigation of the whole plot when it’s installed near one plant? ',
    content: () => {
      return (
        <div className="p-2">
          Our installation process involves conducting a detailed survey of the plot to determine variations in soil
          type and root zone. Based on the survey results, we select an installation point using a plant of average
          growth to represent the entire plot.
        </div>
      );
    },
  },
  {
    title: 'What is the use of Leaf wetness and Lux sensor?',
    content: () => {
      return (
        <div className="p-2">
          We use leaf wetness data to predict airborne foliar diseases, and light intensity (measured with a lux meter)
          to predict both disease and pest incidence.
        </div>
      );
    },
  },
  {
    title:
      'How can the soil moisture sensor monitor the irrigation of the whole plot when it’s installed near one plant? ',
    content: () => {
      return (
        <div className="p-2">
          The installation process includes conducting a detailed survey of the plot to assess variations in soil type
          and root zone. Based on the survey, a suitable installation point is selected with a plant of average growth
          representing the entire plot.
        </div>
      );
    },
  },
  {
    title: 'What is Delta T & VPD? ',
    content: () => {
      return (
        <div className="p-2">
          <p>
            Delta T is the difference between the dry bulb temperature value and the wet bulb temperature value. When
            this value falls between 2 to 9, the stomatal cells on the plant leaf remain open, making foliar application
            such as systemic spray or PGR application more effective. On the other hand, VPD represents vapor pressure
            deficit, which is the optimal time for fertigation when a plant&apos;s active absorption is at its highest.
          </p>
        </div>
      );
    },
  },
  {
    title: 'When should we take the petiole and soil samples for testing? ',
    content: () => {
      return <div className="p-2">It varies with the crop</div>;
    },
  },

  {
    title: 'What is the accuracy of weather prediction, disease, and pest prediction &irrigation? ',
    content: () => {
      return (
        <div className="p-2">
          All of the agronomic algorithms and insights provided have an accuracy of 93%, while the weather algorithms
          have an accuracy of 65-70%
        </div>
      );
    },
  },
  {
    title: 'What is the difference between the predicted delta and the calculated delta? ',
    content: () => {
      return (
        <div className="p-2">
          The predicted delta is derived from weather prediction data, whereas the calculated delta is derived from live
          data.
        </div>
      );
    },
  },
  {
    title: 'What are degree days?',
    content: () => {
      return (
        <div className="p-2">
          Degree days refer to the sum of temperature (heat) accumulated during the growth of the crop. In clear terms,
          it can also be called the age of the crop.
        </div>
      );
    },
  },
  {
    title: 'Is there any subsidy or EMI options available for Fyllo device? 		',
    content: () => {
      return (
        <div className="p-2">
          <ul className="list-disc">
            <li>
              No subsidy but efforts are going on to licensing with Govt. We believe the process will be accelerated
              with the help of Dhanuka.
            </li>
            <li>EMI options are available.</li>
          </ul>
        </div>
      );
    },
  },
  {
    title: 'Is there any sensor for nutrition management? ',
    content: () => {
      return <div className="p-2">No</div>;
    },
  },
  {
    title: 'Why there is a need for an annual recharge?',
    content: () => {
      return (
        <div className="p-2">
          Annual recharge for the sim card is done to send and receive the data from our server whenever required. Also
          farms data is securely saved on cloud so that farmers can access their data when needed.
        </div>
      );
    },
  },
  {
    title: 'What is the life of the device and how much is the warranty? ',
    content: () => {
      return (
        <div className="p-2">
          The life of the device is 5-6 years and it comes with a warranty of 2 years except for any physical damage.
        </div>
      );
    },
  },
  {
    title: 'What makes Fyllo different from its competitors? Or How Fyllo is different from others? ',
    content: () => {
      return (
        <div className="p-2">
          <ul className="list-disc">
            <li>
              Precision & accuracy: Our unique installation process and positioning of sensors help us provide the most
              precise insights with maximum accuracy.
            </li>
            <li>
              Agronomical Algorithms: Any sensor in the market can track the Data of all-weather parameters, but Fyllo’s
              Agronomical models make us unique which are created by a team of scientists led by Dr. Shikhamany who is
              considered by many as the father of Indian grape industry.
            </li>
            <li>
              100% customer retention: Fyllo is known for its service on the ground i.e any issue or ticket raised gets
              solved within 24 hours of time regarding any agronomical assistance & maintenance bringing Customer
              delight.{' '}
            </li>
            <li>
              User-friendly Interface: Fyllo provides the most user-friendly application easy to understand for any
              individual of any language, Age group.
            </li>
          </ul>
        </div>
      );
    },
  },

  {
    title: 'How I check my Fyllo app version? Or How do I know my Fyllo app is updated or not?',
    content: () => {
      return (
        <div className="p-2">
          <ul className="list-disc">
            <li>In Fyllo app go to hamburger menu (click on “≡” three lines) </li>
            <li>Scroll down, you will see Fyllo logo and app version under it.</li>
          </ul>
        </div>
      );
    },
  },
  // {
  // 	title: "When should we take the petiole and soil samples for testing? ",
  // 	content: () => {
  // 		return (
  // 			<div className="p-2">

  // 			</div>);
  // 	},
  // },
];
